import { ApiErrorDetail } from '../types/api';

// Shared infrastructure for the backend's 400 { message, details: [{ path,
// message }] } validation envelope (sb-express-app's ZodValidators.js).
// Forms wire mapDetailsToFieldErrors onto their inputs per-form as they
// adopt it; this file only has to get the shape right once.

// Keeps only well-formed { path: string, message: string } entries, so a
// malformed or unexpected details[] shape never surfaces as
// "[object Object]" or throws while rendering.
export function sanitizeDetails(details: unknown): ApiErrorDetail[] {
  if (!Array.isArray(details)) return [];

  const sanitized: ApiErrorDetail[] = [];
  for (const entry of details) {
    if (!entry || typeof entry !== 'object') continue;
    const { path, message } = entry as { path?: unknown; message?: unknown };
    if (typeof message !== 'string' || !message) continue;
    sanitized.push({ path: typeof path === 'string' ? path : '', message });
  }
  return sanitized;
}

// Maps a details[] array onto a { field: message } record so a form can
// render each violation against its own input. An entry with an empty path
// is a form-level (not field-tied) violation and collects under the '' key.
// When two details share a path, the later one wins.
export function mapDetailsToFieldErrors(details: unknown): Record<string, string> {
  const fieldErrors: Record<string, string> = {};
  for (const { path, message } of sanitizeDetails(details)) {
    fieldErrors[path] = message;
  }
  return fieldErrors;
}
